import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useChurchesStore } from '../store/churchesStore'
import { deleteChurch } from '../utils/deleteChurch'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useDeleteChurchMutation = (onSuccess?: () => void) => {
  const remove = useChurchesStore((state) => state.remove)

  return useMutation({
    mutationFn: deleteChurch,
    onSuccess: ({ message, id }) => {
      remove(id)
      toast.success(message || 'Church deleted successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'An error occurred while deleting church.')
    },
  })
}
